import type { LocationQuery, RouteLocationRaw } from 'vue-router'

import type { BillingReturnParam } from './BillingReturnFlow'

export interface BillingQueryContext {
  path: string
  value: string
  query: LocationQuery
}

export type BillingQueryHandler = (
  context: BillingQueryContext,
) =>
  | void
  | { redirect: RouteLocationRaw }
  | { preserve: true }
  | Promise<void | { redirect: RouteLocationRaw } | { preserve: true }>

export type BillingQueryRegister = (param: string, handler: BillingQueryHandler) => void

export interface BillingReturnRuntime {
  handle: (param: BillingReturnParam, value: string) => Promise<{ redirect: RouteLocationRaw }>
  rejectUnknown: () => Promise<{ redirect: RouteLocationRaw }>
}

export function registerBillingQueryCallbacks(
  register: BillingQueryRegister,
  runtime: BillingReturnRuntime,
): void {
  for (const param of ['stripe_session', 'package_downgraded'] as const) {
    register(param, ({ path, value }) => {
      // The dedicated view owns its own lifecycle. Preserve the param until that view replaces the
      // whole route; otherwise root useQueryCallbacks and the view would perform the reload twice.
      if (path === '/billing/return') return { preserve: true }
      return runtime.handle(param, value)
    })
  }
}
